import VimeoPlayer from '@vimeo/player';
import loadYoutubeIframeApi from './load-youtube-iframe-api';

export function isElementInViewport(id) {
  const el = document.getElementById(id);
  if (el) {
    const { top, bottom } = el.getBoundingClientRect();
    const vHeight =
      (window.innerHeight || document.documentElement.clientHeight) / 2;

    return (top > -100 || bottom > vHeight) && top < vHeight;
  }
  return false;
}

// Sample when function that will only run a function
// if the predicate is true.
/**
 *
 * @param {function} predicate - a predicate function that takes in argumetns and returns a boolean
 * @param {function} fn - a function to be called when the predicate evaluates to true
 * @returns {function} - a function that takes in arguments that will be passed through to the predicate and callback function
 */
export function when(predicate, fn) {
  return function conditional(...args) {
    if (predicate(...args)) {
      return fn(...args);
    }
  };
}

/**
 * hasClass - simple vanilla js helper to check if an element has a class
 *          - compatable with IE 11 using indexOf() rather than the includes() method
 *
 * @param  {HTMLElement} element ex. dom element for targeting
 * @param  {string} cls     the class to check against
 * @return {boolean}         returns true if class exists, false if not
 */

export function hasClass(element, cls) {
  if (!element) return false;

  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

/**
 * const addClass - add class helper to element
 *
 * @param  {HTMLElement} elem  element
 * @param  {string} cls classes  ex. 'is-open'
 */

export function addClass(elem, cls) {
  elem.classList.add(cls);
}

/**
 * const removeClass - add class helper to element
 *
 * @param  {HTMLElement} elem  element
 * @param  {string} cls class  ex. 'is-open'
 */

export function removeClass(elem, cls) {
  elem.classList.remove(cls);
}

/**
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
export function serialize(form) {
  // Setup our serialized data
  var serialized = [];
  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];
    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === 'file' ||
      field.type === 'reset' ||
      field.type === 'submit' ||
      field.type === 'button'
    )
      continue;
    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(
          encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(field.options[n].value)
        );
      }
    }
    // Convert field data to a query string
    else if (
      (field.type !== 'checkbox' && field.type !== 'radio') ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    }
  }
  return serialized.join('&');
}

/**
 *
 * @param  {string} swiperId video carousel id
 */
let youtubeIframeAPI,
  youtubePlayersByVideoSrc = {};
export function videoPlayerHandler(swiperId) {
  const embeddedVideos = document.querySelectorAll(
    `${swiperId} .swiper-slide:not(.swiper-slide-duplicate) iframe`
  );
  let player, videoSrc;
  embeddedVideos.forEach(embeddedVideo => {
    videoSrc = embeddedVideo.getAttribute('src');
    if (videoSrc && videoSrc.indexOf('vimeo') >= 0) {
      player = new VimeoPlayer(embeddedVideo);
      player.pause();
    } else if (videoSrc && videoSrc.indexOf('youtube') >= 0) {
      if (!youtubeIframeAPI) youtubeIframeAPI = loadYoutubeIframeApi();

      youtubeIframeAPI
        .then(YT => {
          return new Promise(resolve => {
            if (typeof youtubePlayersByVideoSrc[videoSrc] === 'object') {
              resolve(youtubePlayersByVideoSrc[videoSrc]);
            } else {
              player = new YT.Player(embeddedVideo, {
                events: {
                  onReady: event => {
                    youtubePlayersByVideoSrc[videoSrc] = event.target;
                    resolve(event.target);
                  },
                },
              });
            }
          });
        })
        .then(player => {
          player.pauseVideo();
        });
    }
  });
}

/**
 * const disableScroll - disable scrolling on body for modals
 *
 * @param {bool}
 */

export function disableScroll(bool) {
  if (bool) {
    addClass(document.body, 'no-scroll');
    addClass(document.documentElement, 'no-scroll');
  } else {
    removeClass(document.body, 'no-scroll');
    removeClass(document.documentElement, 'no-scroll');
  }
}

/**
 * const goToCurrentScroll - add overflow hidden on body for modals
 *
 * @param {bool}
 */

export function goToCurrentScroll(bool) {
  if (bool) {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
  } else {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
}

/**
 *
 * @param {Object} obj
 * @param {Array} keys
 */
export function objectHasKeysDefined(obj, keys) {
  const ret = keys.filter(val => obj.hasOwnProperty(val));
  console.log(ret);
  return ret.length == keys.length;
}

/**
 *
 * @param {String} str
 * @returns {String}
 */
export function htmlEntities(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/\*/g, '&#42;')
    .replace(/\+/g, '&#43;');
}

/**
 *
 * @param {Array} array
 * @returns {Array}
 */
export function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export function getWindowHeight() {
  if (document.compatMode === 'BackCompat') {
    return document.body.clientHeight;
  } else {
    return document.documentElement.clientHeight;
  }
}

export const getPageVariable = variableName => {
  const variableValueContainer = document.querySelector(
    `ul#js-page-variables > li[rel="${variableName}"]`
  );

  if (!variableValueContainer) return;

  return JSON.parse(variableValueContainer.innerHTML);
};

export const isFeatureEnabled = featureName =>
  getPageVariable(`${featureName}Enabled?`);

export const isFeatureDisabled = featureName => !isFeatureEnabled(featureName);

export const analyticsPageName = () => getPageVariable('analyticsPageName');

export const isDealerPage = () => getPageVariable('isDealerPage?');
export const isOemPage = () => getPageVariable('isOemPage?');
export const showOrderSheetBarrel = () => getPageVariable('sheetOrdering?');
export const showExternalPointSupport = () =>
  getPageVariable('showExternalPointSupport?');
export const showExternalSuspend = () =>
  getPageVariable('showExternalSuspend?');
export const useSampleLimits = () => getPageVariable('sampleLimits?');
export const useMaterialDetailsBlock = () =>
  getPageVariable('materialDetailsBlock?');
export const elasticsearchSiteSearchEnabled = () =>
  isFeatureEnabled('elasticsearchSiteSearch');

// Used only as a fun prank
export const useChaoticNav = () => getPageVariable('chaoticNav?');

export const openModalWhenReady = modal => {
  const openModalLink = document.querySelector(
    `[data-micromodal-trigger="${modal.id}"]`
  );

  if (openModalLink) {
    window.addEventListener('DOMContentLoaded', () => {
      openModalLink.dispatchEvent(new MouseEvent('click'));
    });
  }
};

export const namespacedObject = (namespaces, object = {}) => {
  if (!namespaces) return object;

  if (!Array.isArray(namespaces)) namespaces = [namespaces];

  for (const namespace of namespaces) {
    object = object[namespace] = object[namespace] || {};
  }

  return object;
};

export const waitForElement = async selector => {
  while (!document.querySelector(selector)) {
    await new Promise(resolve => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};

export const useAddToCartModal = () => {
  const modalEl = document.getElementById('add-to-cart-modal');
  const confirmationEl = document.getElementById('add-to-cart-confirmation');
  const closeButtonEl = document.getElementById(
    'add-to-cart-confirmation__close'
  );

  if (!!modalEl) modalEl.style.display = 'inherit';
  if (!!confirmationEl) confirmationEl.style.display = 'none';
  if (!!closeButtonEl) closeButtonEl.style.display = 'none';
};

export const useCartConfirmationModal = () => {
  const modalEl = document.getElementById('add-to-cart-modal');
  const confirmationEl = document.getElementById('add-to-cart-confirmation');
  const closeButtonEl = document.getElementById(
    'add-to-cart-confirmation__close'
  );

  if (!!modalEl) modalEl.style.display = 'none';
  if (!!confirmationEl) confirmationEl.style.display = 'inherit';
  if (!!closeButtonEl) closeButtonEl.style.display = 'inherit';
};

export const externalNgLoader = async () => {
  if (!window.externalNgLoaded) {
    const ngVersionPath = '/proxy/configurations/external_ng_version';
    const getInit = { method: 'GET', headers: { Accept: 'application/json' } };
    fetch(ngVersionPath, getInit)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
      })
      .then(async json => {
        const version = json?.configuration?.value;
        // only add it if we get a valid version number
        if (version) {
          var script = document.createElement('script');
          script.defer = true;
          script.src = `https://ngapps.3-form.com/external/main.js?_=${version}`;
          await document.body.appendChild(script);
        }
      })
      .catch(error => {
        logErrorToSentry(error);
      });
  }
};

export const logErrorToSentry = error => {
  console.error('Error:', error);
  if (!window.Sentry) return;
  Sentry.captureException(error);
};
